
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bang-gia/ty-gia",
      function () {
        return require("private-next-pages/bang-gia/ty-gia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bang-gia/ty-gia"])
      });
    }
  